import React from "react";
import "./NewsCard.css";

const NewsCard6 = () => {
  const handleSourceClick = () => {
    window.open("https://thebftonline.com/2022/06/13/gss-actuaries-to-develop-national-mortality-table/", "_blank");
  };

  return (
    <div>
    <section className="section-council">
    <div className="sectiontop-line"></div>
    <h2 className="sectiontitle">LATEST NEWS</h2>
    <div className="sectionbottom-line"></div>
    </section>
    <h2 className="newstoptitle">
    GSS, actuaries to develop National Mortality Table
    </h2>
    <div className="newscard">
    
      <img
        src="images\News\news3.jpeg" 
        alt="News"
        className="newsimage"
      />

     
      <h3 className="newstitle">
        GSS, actuaries to develop National Mortality Table
      </h3>

     
      <div className="newsmeta">
        <span className="newssource">
          Source:{" "}
          <button onClick={handleSourceClick} className="sourcelink">
            www.thebftonline.com
          </button>
        </span>
        <span className="newsdate">Mon, 13 June 2022</span>
      </div>

      
      <p className="newsdescription">
        Ghana's actuarial community is nearing a major milestone: the near
        completion of the Assured Life Mortality Table, which aims to transform
        life insurance practices in the country.
        <br />
        <br />
        The project, which is expected to be finalised by the first quarter of
        2025, was highlighted at the 2024 Actuarial Society of Ghana (ASG),
        Actuaries Connect Conference, alongside other initiatives aimed at
        advancing actuarial expertise and improving the broader insurance
        sector.
        <br />
        <br />
        The Assured Life Mortality Table, currently 80% complete, will allow
        life insurers to assess mortality risks with greater accuracy and
        relevance to Ghana's population.
        <br />
        <br />
        The project, which is expected to be finalised by the first quarter of
        2025, was highlighted at the 2024 Actuarial Society of Ghana (ASG),
        Actuaries Connect Conference, alongside other initiatives aimed at
        advancing actuarial expertise and improving the broader insurance
        sector.
        <br />
        <br />
        The Assured Life Mortality Table, currently 80% complete, will allow
        life insurers to assess mortality risks with greater accuracy and
        relevance to Ghana's population.
        <br />
        <br />
        The project, which is expected to be finalised by the first quarter of
        2025, was highlighted at the 2024 Actuarial Society of Ghana (ASG),
        Actuaries Connect Conference, alongside other initiatives aimed at
        advancing actuarial expertise and improving the broader insurance
        sector.
        <br />
        <br />
        The Assured Life Mortality Table, currently 80% complete, will allow
        life insurers to assess mortality risks with greater accuracy and
        relevance to Ghana's population.
      </p>
    </div>
    </div>
  );
};

export default NewsCard6;
